<br>
<div *ngIf="momentImpression">{{momentImpression | date}}</div>
<div class="col-12">
    <div class="form-row">
        <div class="col-md-5">
            <h2 class="mb-3"><b>Impression du formulaire</b></h2>
        </div>
        <!-- Pour l'impression -->
        <div class="col-md-5" *ngIf="rootForm && (modeRenduService.enModeImpression$ | async)">
            <div class="form-row py-2 mb-3">
                <div>
                    <button class="btn btn-warning mx-1" title="Retour au questionnaire"
                        (click)="modeRenduService.revenirModeDefaut()">
                        <i class="material-icons md-18 mr-1" aria-hidden="true">edit</i>Retour au questionnaire</button>
                </div>
            </div>

        </div>
    </div>
</div>
<br>
<bis-questionnaire></bis-questionnaire>